module.exports = __webpack_public_path__ + "static/title-bg1.2ebfb3f5.png";